// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__3zQzx","list":"List_list__11dcK","add":"List_add__ZxMwj","mobile":"List_mobile__1Yx8y","dragging":"List_dragging__2NxDX","addCard":"List_addCard__i8DNg"};